// extracted by css-extract-rspack-plugin
export default {"formElement":"formElement__jDrJ2","formButton":"formButton__ronK9"};